const  Constants = { 
    DATE_FORMAT : "D-M-YYYY",
    DATE_FORMAT_YEAR : "YYYY",
    API_DATE_FORMAT : "D/M/YY",
    BID_DATE_FORMAT : "DD/MM/YY HH:mm",
    BID_DATE_FORMAT_AM_PM : "DD/MM/YY hh:mm A",
    DATE_FORMAT_MM_DD_YYYY : "MM/DD/YYYY",
    DATE_FORMAT_MM_DD_YY : "MM/DD/YY",
    DATE_FORMAT_D_M_YYYY : "D/M/YYYY",
    DATE_FORMAT_TASKS : 'dddd, MMMM DD, YYYY',
    DATE_FORMAT_MM_DD_YY_HYPHEN : "MM-DD-YY",
    DATE_FORMAT_MM_DD_YYYY_HH_MM_SS:"MM/DD/YYYY hh:mm:ss",
    DATE_FORMAT_IN_MM_DD_YYYY_HH_MM_SS:"DD-MM-YYYY hh:mm:ss",
    DATE_FORMAT_IN_MM_DD_YYYY_HH_MM:"DD-MM-YYYY hh:mm",
    DATE_FORMAT_DDDD_MMM_D_YYYY:"dddd, MMM D, YYYY",
    DATE_FORMAT_LL_HH_MM:"ll hh:mm",
    DATE_FORMAT_LL_HH_MM_SS:"ll hh:mm:ss",
    DATE_FORMAT_LL_HH_MM_SS_A:"ll hh:mm:ss a",
    TIME_FORMAT : "h:mm:ss A z",
    DATE_FORMAT_YYYY_MM_DD_HH_MM_SS:"YYYY-MM-DD HH:mm:ss",
    DELIVERY_STATUS_ON_TRACK : "ON_TRACK",
    DELIVERY_STATUS_AT_RISK : "AT_RISK",
    DELIVERY_STATUS_LATE : "LATE",
    ONLY_DATE_FORMAT : "DD",
    ONLY_MONTH_FORMAT_NAME : "MMM",
    DATE_FORMAT_MM_DD_YYYY_24_HH_MM_SS:"MM/DD/YYYY HH:mm:ss",
    DELIVERY_STATUS_UNKNOWN : "UNKNOWN",
    CAMPAIGN : "Campaign",
    DELIVERY_STATUS : "Delivery_Status",
    CONTENT_SOURCE : "Content_Source",
    INTENDED_USE : "Intended_Use",
    PROJECT_ID : "Project_Id",
    TRANSLATIONS_BY : "Translations_By",
    PROJECT_OWNER : "Project_Owner",
    PURCHASE_ORDER : "Purchase_Order",
    SOURCE_LANGUAGE : "Source_Language",
    TAGS : "Tags",
    TARGET_LANGUAGE : "Target_Language",
    INVALID_FILE_EXTENSION : "ICR may get affected because of the mismatched extension type",
    PROJECT_FOLLOWERS_TOOLTIP : "People on this list will receive notifications about this project. Those who are assigned tasks are automatically added to this list, and cannot be removed. To remove them, first reassign their tasks.",
    MTQE_TOOLTIP : "This label conveys that you are setting a threshold value. When the average MTQE score for selected assets exceeds this threshold, the workflow will skip the Post-Editing (PE) stage and proceed directly to the review part.",
    BIDS_TOOLTIP: "You will be able to select quotes once your accounts payable information is verified by OPAL-Marketing. Verification can take five business days. To speed up verification, contact us at <a>AccountsReceivable@cloudwords.com</a> or 1-415-3994-8012.",
    SETTINGS_DEPT_TOOLTIP : "Select the departments this user has access to, along with the default project following settings for each department.  Note, Administrators always have access to all departments.",
    MY_ACCT_LANG_TO_REVIEW_TOOLTIP : "Select the languages you can review and want to be associated with. Language review tasks on a project will include users who are following that project and are associated to the language delivered by the vendor.",
    MY_ACCT_LANG_PAIRS_TO_TRANSLATE : "Select the language pairs you are available to translate.",
    VENDOR_BID_DEADLINE_TOOLIP:" This is the deadline by which vendors must submit their quote. They can submit it at any time before the selected date.",
    PURCHASE_ORDER_TOOLTIP:"This project requires a Purchase Order to be set, but you do not need to select it at this time. If you do not select a purchase order now, a purchase order may be selected when the winning quote is chosen.",
    TARGET_LANGUAGE_TOOLTIP:"You can customize the list of languages by choosing the Project Settings option under the Settings link at the top of this page.",
    BID_SELECTION_DEADLINE_TOOLTIP:"The deadline for selecting a winning quote is determined based on your quote submission and initial translation deadline.",
    DEADLINE_VENDOR:"This is the deadline for the vendor to deliver the first translations, so you can start reviewing them. If this project is part of a campaign, this date must be before the campaign due date.",
    PROJECT_FOLLLOWERS:"People on this list will receive notifications about this project. Those who are assigned tasks are automatically added to this list, and cannot be removed. To remove them, first reassign their task",  
    BID_SUBMISSION_TOOLTIP : "This is the deadline by which vendors must submit their quote. They can submit it at any time before the selected date.",
    TRANSLATION_SUBMISSION_TOOLTIP: "This is the deadline for the vendor to deliver the first translations, so you can start reviewing them. If this project is part of a campaign, this date must be before the campaign due date.",
    BID_SELECTION_DEADLINE_TOOLTIP: "The deadline for selecting a winning quote is determined based on your quote submission and initial translation deadline.",
    BEST_MATCHED_INTERNAL_TRANSLATORS_TOOLTIP: "These internal translators can translate all languages in your project.",
    SKIP_TRANSLATION_MEMORY_UPLOAD_TOOLTIP: "Checking this will enable the vendor to close the project without uploading any associated Translation Memory.",
    DATE_HOUR_MIN_SEC : "MM/DD/YYYY hh:mm:ss",
    PREVIEW_TRANSLATED : "Please add complete email address of the Lead to search",
    SELECT_TARGET_LANGUAGE : "Indicates source language segment",
    SELECT_PREVIEW_CONTACT : "Indicates source language",
    HOUR_MIN_SEC_AM_PM :"hh:mm:ss A",
    HOUR_MIN_24_HR_FORMAT : "H:mm",
    DATE_HOUR_YEAR_MIN_SEC : "DD/MM/YY hh:mm:ss A",
    MONTH_DATE_YEAR_MIN_SEC : "MM/DD/YY hh:mm:ss A",
    ZIP_FILE_EXTENSION : ".zip",
    DATE_COMPARE_FORMAT : "MM-DD-YYYY",
    HOUR_MIN_AM_PM : "hh:mm A",
    HOUR_AM_PM : "h A",
    DATE_IN_WORDS : "dddd, MMM DD, YYYY",
    DATE_IN_WORDS_WITH_TIME : "dddd, MMM DD, YYYY hh:mm A",
    DATE_MONTH_YEAR: "MM/YYYY",
    STANDARD_CONTENT_TYPE : "STANDARD",
    STANDARD_CONTENT_TYPE_DISPLAY : "Local Files",
    ELOQUA_CONTENT_TYPE_DISPLAY : "Eloqua",
    BAD_CREDENTIALS : "Bad credentials",
    INTERNAL_SERVER_ERROR : "Internal Server Error",
    INVALID_CREDENTIALS : "Invalid user name and/or password. Please try again.",
    SOMETHING_WENT_WRONG : "Something went wrong.",
    MARKETO : "MARKETO",
    MARKETOREST : "MARKETOREST",
    MARKETING_ACTIVITY: "marketingActivity",
    DESIGN_STUDIO: "designStudio",
    MARKETOREST_CONTENT_TYPE_DISPLAY: "MarketoRest",
    MARKETO_CONTENT_TYPE_DISPLAY: "Marketo",
    ELOQUA : "ELOQUA",
    BRIGHTCOVE : "BRIGHTCOVE",
    PARDOT : "PARDOT",
    EXACTTARGET : "EXACTTARGET",
    STANDARD_EXACTTARGET : "STANDARD_EXACTTARGET",
    DATAEXTENSION : "DATAEXTENSION", 
    VIDYARD: "VIDYARD",
    UBERFLIP: "UBERFLIP",
    LILT_TRANSLATE:"LILT_TRANSLATE",
    LANG_WEAVER_TRANSLATE:"LANG_WEAVER_TRANSLATE",
    IBM_TRANSLATE:"IBM_TRANSLATE",
    GOOGLE_TRANSLATE:"GOOGLE_TRANSLATE",
    MICROSOFT_TRANSLATE:"MICROSOFT_TRANSLATE",
    MICROSOFT_TRANSLATE_V3:"MICROSOFT_TRANSLATE_V3",
    VIDYARD_CONTENT_TYPE_DISPLAY : "Vidyard",
    UBERFLIP_CONTENT_TYPE_DISPLAY : "Uberflip",
    BRIGHTCOVE_CONTENT_TYPE_DISPLAY: "Brightcove",
    VIDEO : "Video",
    VIDEO_CAPS : "VIDEO",
    IMAGE: "IMAGE",
    CAPTIONS : "captions",
    CAPTIONS_CAMEL : "Captions",
    CAPTIONS_CAPS : "CAPTIONS",
    STANDARD : "STANDARD",
    SOURCE_MATERIAL_STEP_2 : "Source Material Step 2",
    LANGUAGE_AND_REFERENCE_MATERIAL : "Language and Reference Material",
    UPLOAD_IMAGE_STEP : "Upload Image Step",
    FOLDER : "Folder",
    EMAIL : "Email",
    EMAIL_HEADER : "EMAIL_HEADER",
    EMAIL_HEADER_LABEL : "Email Header",
    EMAIL_HEADER_CAMEL_CASE : "EmailHeader",
    EMAIL_FOOTER : "EMAIL_FOOTER",
    EMAIL_FOOTER_LABEL : "Email Footer",
    EMAIL_FOOTER_CAMEL_CASE : "EmailFooter",
    LANDINGPAGE : "LandingPage",
    FORM : "Form",
    ESCAPE : "Escape",
    DESC : "DESC",
    DESCENDING : "descending",
    ASCENDING : "ascending",
    NO_DATA_FOUND : "No data found",
    NO_CHANGE_ORDER : "Currently there are no change orders",
    NO_RECORD_FOUND: "There are no records to display",
    NO_NOTIFICATION_FOUND: "No new notifications",
    LANDING_PAGE_TEMPLATE: "Landing Page Template",
    LANDING_PAGE_TEMPLATE_CODE: "LANDING_PAGE_TEMPLATE",
    LANDING_PAGE: "Landing Page",
    LANDING_PAGE_CODE: "LANDING_PAGE",
    EMAIL_TEMPLATE: "Email Template",
    EMAIL_TEMPLATE_CODE: "EMAIL_TEMPLATE",
    EMAIL_CODE: "EMAIL",
    LP_FORM:"Landing Page Form",
    NORMAL_FORM:"Form",
    LP_FORM_CODE:"FORM",
    SNIPPET:"Snippet",
    SNIPPET_CODE:"SNIPPET",
    WS_ZONE:"Zone",
    WS_CODE:"WORKSPACE",
    SMART_CAMPAIGN:"Smart Campaign",
    CAMPAIGN_CODE:"CAMPAIGN",
    MARKETO_PROGRAM_STR: "Marketing Program",
    MARKETING_PROGRAM_CODE:"MARKETING_PROGRAM",
    EXTERNAL_BIDLESS : "EXTERNAL_BIDLESS",
    INTERNAL : "INTERNAL",
    EXTERNAL : "EXTERNAL",
    BLANK : "",
    SINGLE_WHITESPACE : " ",
    STATIC_ASSEST:"staticAsset",
    DYNAMIC_ASSET:"dynamicAsset",
    ENTER: 'Enter',
    CLICK: 'click',
    TAB: 'Tab',
    ENABLE_DEP:"true",
    DISABLE_DEP:"false",
    ENABLE_REVIEWER_EDITING:"ENABLE_REVIEWER_EDITING",
    SELECT: 'Select',
    ACTIVATE: 'Activate',
    DEACTIVATE: 'Deactivate',
    SUCCESS: 'success',
    FAILURE: 'failure',
    ERROR: 'error',
    MARKETOREST_ACCESS: 'MARKETOREST_ACCESS',
    BRIGHTCOVE_ACCESS: 'BRIGHTCOVE_ACCESS',
    ELOQUA_ACCESS : "ELOQUA_ACCESS",
    PARDOT_ACCESS : "PARDOT_ACCESS",
    VIDYARD_ACCESS : "VIDYARD_ACCESS",
    UBERFLIP_ACCESS : "UBERFLIP_ACCESS", 
    EXACTTARGET_ACCESS : "EXACTTARGET_ACCESS",
    PARDOT_CONTENT_TYPE_DISPLAY: "Pardot",
    EXACTTARGET_CONTENT_TYPE_DISPLAY: "ExactTarget",
    ENABLE_MARKETOREST_INTEGRATION:'ENABLE_MARKETOREST_INTEGRATION',
    ENABLE_ELOQUA_INTEGRATION:'ENABLE_ELOQUA_INTEGRATION',
    ENABLE_HUBSPOT_INTEGRATION:'ENABLE_HUBSPOT_INTEGRATION',
    ENABLE_RESPONSYS_INTEGRATION:'ENABLE_RESPONSYS_INTEGRATION',
    ENABLE_EXACTTARGET_INTEGRATION:'ENABLE_EXACTTARGET_INTEGRATION',
    ENABLE_BRIGHTCOVE_INTEGRATION:'ENABLE_BRIGHTCOVE_INTEGRATION',
    ENABLE_PARDOT_INTEGRATION:'ENABLE_PARDOT_INTEGRATION',
    ENABLE_VIDYARD_INTEGRATION : 'ENABLE_VIDYARD_INTEGRATION',
    ENABLE_UBERFLIP_INTEGRATION : "ENABLE_UBERFLIP_INTEGRATION",
    ENABLE_MACHINE_TRANSLATION:'ENABLE_MACHINE_TRANSLATION',
    MARKETO_INTEGRATION:'MARKETO_INTEGRATION',
    MARKETOREST_INTEGRATION:'MARKETOREST_INTEGRATION',
    ELOQUA_INTEGRATION:'ELOQUA_INTEGRATION',
    BRIGHTCOVE_INTEGRATION:'BRIGHTCOVE_INTEGRATION',
    PARDOT_INTEGRATION:'PARDOT_INTEGRATION',
    VIDYARD_INTEGRATION:'VIDYARD_INTEGRATION',
    UBERFLIP_INTEGRATION:'UBERFLIP_INTEGRATION',
    ONEDRIVE_INTEGRATION:'ONEDRIVE_INTEGRATION',
    VEEVA_VAULT_INTEGRATION:'VEEVA_VAULT_INTEGRATION',
    HUBSPOT_INTEGRATION:'HUBSPOT_INTEGRATION',
    GOOGLEDRIVE_INTEGRATION:'GOOGLEDRIVE_INTEGRATION',
    EXACTTARGET_INTEGRATION:'EXACTTARGET_INTEGRATION',
    MACHINE_TRANSLATION:'MACHINE_TRANSLATION',
    MARKETO_DESIGN_STUDIO_FOLDER_ID: "MARKETO_DESIGN_STUDIO_FOLDER_ID",
    MARKETO_MARKETING_ACTIVITY_FOLDER_ID: "MARKETO_MARKETING_ACTIVITY_FOLDER_ID",
    BLOG_SMALL: 'blog',
    BLOG: "BLOG",
    BLOG_CAMEL: "Blog",
    STREAMS_CAMEL : "Streams",
    BLOG_POST_SMALL : "blog_post",
    BLOG_POST : "BLOG_POST",
    ELOQUA_ACCESS_CHANGE_GRANT : "ELOQUA_ACCESS_CHANGE_GRANT",
    CUSTOM : "CUSTOM",
    TAB: 'Tab',
    ALL:'all',
    UN_READ:'unread',
    HTTP: "http:",
    HTTPS: "https:",
    PROJECT_BID_MAX_VENDOR_SELECTION_COUNT : 5,
    USER_DEPARTMENT_FILTER: "department",
    USER_ROLE_FILTER: "role",
    USER_REVIEW_LANGUAGE_FILTER : "reviewLanguage",
    USER_ACCOUNT_STATUS_FILTER: "accountStatus",
    USER_NAME_FILTER: "name",
    USER_EMAIL_FILTER: "email",
    ROLE_NAME:"&roleName=",
    NEW_USER_DEPARTMENTS_TOOLTIP: "Select the departments this user has access to, along with the default project following settings for each department.  Note, Administrators always have access to all departments.",
    ROLE_INTERNAL_TRANSLATOR: "ROLE_CUSTOMER_INTERNAL_TRANSLATOR",
    ROLE_PROJECT_REQUESTER: "ROLE_CUSTOMER_PROJECT_REQUESTER",
    ROLE_QUOTE_APPROVER: "ROLE_CUSTOMER_QUOTE_APPROVER",
    ROLE_CUSTOMER_ADMIN: "ROLE_CUSTOMER",
    ROLE_PROJECT_MANAGER: "ROLE_CUSTOMER_PROJECT_MANAGER",
    ROLE_REVIEWER: "ROLE_CUSTOMER_REVIEWER",
    ROLE_TYPE_PROJECT_REQUESTER : "CUSTOMER_PROJECT_REQUESTER",
    ROLE_TYPE_CUSTOMER_USER : "CUSTOMER_USER",
    ROLE_TYPE_QUOTE_APPROVER : "CUSTOMER_QUOTE_APPROVER",
    FIRST_NAME : "firstName",
    LAST_NAME: "lastName",
    CANCEL: "Cancel",
    DYNAMIC: "DYNAMIC",
    STATIC: "STATIC",
    PROGRAM : "PROGRAM",
    PREFERRED_FILTER: "facet_preferred_show",
    NON_PREFERRED_FILTER: "facet_preferred_show_non",
    INTERNAL_FILTER: "facet_internal_translator",
    NUMBER: "number",
    DUE_DATE: "dueDate",
    PROJECT: "project",
    PROJECT_DELIVERY_DEADLINE_WARNING : "PROJECT_DELIVERY_DEADLINE_WARNING",
    PROJECT_BID_SELECTION_DEADLINE_WARNING : "PROJECT_BID_SELECTION_DEADLINE_WARNING",
    LANGUAGE_REVIEW_TASK_DUE_WARNING : "LANGUAGE_REVIEW_TASK_DUE_WARNING",
    CLOSE_PROJECT_PENDING_WARNING : "CLOSE_PROJECT_PENDING_WARNING",
    INCOMPLETE_TASK_DUE_WARNING : "INCOMPLETE_TASK_DUE_WARNING",
    ALL_SELECTOR : ".*",
    ONLY_FOLLOWED : "onlyFollowed",
    FILTER_TYPE: "filterType",
    SEMI_COLON : ";",
    UNDERSCORE : "_",
    ASSIGNEE_ERROR : "Assignee error",
    UNDERSCORE_DELIMITER : "___",
    DYNAMIC_CONTENT_START_DELIMITER : "___DYNAMIC_CONTENT",
    DYNAMIC_CONTENT_END_DELIMITER : "DYNAMIC_CONTENT___",
    FIELD_MERGE_REGEX : /___FIELD_MERGE(.*?)FIELD_MERGE___/gi,
    DYNAMIC_CONTENT_REGEX : /___DYNAMIC_CONTENT(.*?)DYNAMIC_CONTENT___/gi,    
    FIELD_MERGE_START_DELIMITER : "___FIELD_MERGE",
    FIELD_MERGE_END_DELIMITER : "FIELD_MERGE___",
    SOURCE_PREVIEW_BUNDLE: "Source Offline Preview (.zip)",
    TARGET_PREVIEW_BUNDLE: "Target Offline Preview (.zip)", 
    TASK_ASSIGN: "Currently there are no open tasks.",  
    NO_ACTIVITY_FEED : "No activity feed found",
    TASK_ALERTS: "Currently there are no alerts.", 
    TASK_TRANSLATION_MEMORY: "The vendor will upload the translation memory of this project once every language has been approved.",      
    TASK_TRANSLATION_MEMORY_FOR_TRANSLATOR: "Translation Memory for all languages can be uploaded by the translator after all translations have been approved, and must be uploaded in one .zip or .tmx file. Uploaded TM must adhere to the OPAL-Marketing TM validation policy.",
    OVERVIEW_SKIP_TM_TASK_MESSAGE : "This project has been configured so the Vendor is not required to upload its translation memory. The vendor will be able to close this project once all translations have been marked as approved. If you want, you can edit this project and change this setting to require the vendor to provide its translation memory.",
    OVERVIEW_SKIP_TM_TASK_MESSAGE_PROJECT_CLOSED : "Translation memory was not required for this project.",
    SENDING_EDITS_TO_ELOQUA_MESSAGE : "Please wait while your edits are synced to Eloqua before the test email is sent. This may take a few minutes. This window will close automatically when the test email with your edits has been sent.",
    IN_PROGRESS : "In Progress",
    currencyNames: {
        USD: "US Dollar",
        EUR: "Euro",
        GBP: "British Pound",
        JPY: "Japanese Yen",
        CNY: "Chinese Yuan",
        BRL: "Brazilian Real",
        KRW: "South Korean",
        ARS: "Argentine Peso",
        SGD: "Singapore Dollar",
        HKD: "Hong Kong Dollar",
      },
    GLOSSARY_SUCCESS_MESSAGE:"You have successfully uploaded a Glossary file and we are now updating your Glossary database. Please check back later.",
    GLOSSARY_DELETE_MESSAGE:"Glossary file deleted successfully and we are now updating your Glossary database. Please check back later.",
    MAX_PHASES_PER_WORKFLOW_STEP : 10, 
    BILINGUAL_FILE_NAME:'BilingualReview-project_',
    PROJECT_DELIVERY_STATUS : {
      ON_TRACK:"On Time",
      AT_RISK:"At Risk",
      LATE:"Late",
      UNKNOWN:"",
      CANCELLED:"Canceled",
      COMPLETED:"Completed"
    },
    PROJECT_STATUS : {
      PROJECT_PREPARING_TM:'preparing_project_tm',
      SOURCE_SYNC_FAILED:'source_sync_failed',
      EXTRACT_XLIFF_FROM_OFFLINE_FILE:'extract_xliff_from_offline_files',
      NO_BID_SUBMITTED:"no_bids_submitted",
      IN_CANCELLATION_WAITING_FOR_CUSTOMER : "in_cancellation_waiting_for_customer",
      ALL_BID_REJECTED : "all_bids_rejected",
      IN_CANCELLATION_WAITING_FOR_VENDOR:"in_cancellation_waiting_for_vendor",
      BID_SELECTION_EXPIRED:"bid_selection_expired",
      CHANGE_ORDER_REQUESTED:"change_order_requested",
      PREPARING_CHANGE_ORDER_TM:"preparing_change_order_tm",
      VENDOR_REJECTED:"vendor_rejected",
      WATING_FOR_BID_SELECTION: "waiting_for_bid_selection"
    },

      VIEW_NAME:"/unauth/verify-newuser",
       ESC_KEYCODE: 27,
       TAB_KEYCODE: 9,
       ENTER_KEYCODE: 13,
       INITIAL_HOUR:4,
       INVALID_PASSWORD:"Current password is invalid",
       CONNECTION_FAILED:"Upload Failed: The connection with OPAL-Marketing was interrupted, Please Choose the valid file and try again",
      VERIFY_NEW_USER_ERROR_MESSAGE:"Password reset link is only good for one time use and is no longer valid. To reset your password again.",
    PROJECT_UPDATE_SUCCESS_MESSAGE:"Changes made to project saved successfully",
    PROJECT_OWNER_UPDATE_MESSAGE:(ownerName)=>`You have successfully reassigned this projects's ownership to ${ownerName}. They will receive an email notification.`,
    CHUNK_SIZE: 5 * 1024 * 1024, // 5 MB
    FILE_TYPE_DOCX: "DOCX",
    FILE_TYPE_XLF: "XLF",
    STYLE_GUIDE_NOT_PRESENT:"No style guide has been uploaded yet.",
    SUBTITLE_FILE_EXTENSIONS : ["vtt","srt"],
    TICKET_GENERATE_EXTERNAL_LINK : 'https://cloudwords.zendesk.com/hc/en-us/requests/new',
    PHASE_TYPE_WORK : "Work",
    PHASE_TYPE_REVIEW : "Review",
    PHASE_TYPE_PE : "post_editing",
    POST_EDITING : "POST_EDITING",
    FINAL_REVIEW : "Final Review",
    APPROVAL_PHASE : "Approval",
    TASK_STATUS:(status)=>`&status=${status}`,
    REVIEW_STATUS:`&type=APPROVE_LANGUAGE_OR_REQUEST_REVISION&type=APPROVE_LANGUAGE_OR_REQUEST_REVISIONS&type=REVIEW_PROJECT_ASSETS`,
    TASK_UPDATE_GLOSSARY : "update_glossary",
    ASSIGNED_ID:(id)=>`&assigneeId=${id}`,
    LEARN_WHY_LINK : "https://cloudwords.codebasehq.com/redirect?https://cloudwords.zendesk.com/entries/23349233",
    PRIVACY_POLICY_LINK: "https://www.welocalize.com/security-compliance/privacy-policy",
    TERMS_LINK: "https://www.welocalize.com/security-compliance/legal-notice-legal-entities",
    NOT_APPLICABLE : "N/A",
    UNASSIGNED_DEPARTMENT:"Unassigned",
    CAMPAIGN_DUE_DATE:"This is the end date for this campaign. All projects must deliver before this date.",
    CAMPAIGN_MEMBER:"People on this list will receive notifications about this campaign. Campaign owners are automatically added to this list, and cannot be removed. To remove them, first reassign the campaign owner.",
    REMOVE_LANG_TOOL_TIP:"Vendors might charge for work already done for languages being canceled. Click to learn more.",
    CHANGE_ORDER_SOURCE_FILE_REMOVED:"This source file will be removed from the project when change order is submitted and approved",
    CHANGE_ORDER_REMOVE_LANG_TOOLTIP : "You can remove a language from the project by clicking on one. Please note that a language cannot be removed from the project if the deliverable for a language has already been approved.",
    REMOVE_LANG_TOOL_TIP_CREATE_CHANGE_ORDER:'The deliverable for this language has already been approved and cannot be removed from the project.',
    CHANGE_ORDER_FILE_CHANGE_NOT_ALLOWED_FOR_LANG_APPROVED : 'You cannot add new files to this project because at least one language has already been approved. If you have new files to translate, you may start a new project or reopen the approved language(s) on the ',
    CHANGE_ORDER_NO_TARGET_LANGUAGE_SELECTED : 'A project must have at least one target language. Please add a target language by selecting a language above.',
    CHANGE_ORDER_FILE_CHANGE_UI_FEATURES : 'This project does not support changing source files through a Change Order. If you have new files to translate, you may start a new project.',
    CHANGE_ORDER_TARGET_LANGUAGE_UI_FEATURES : 'This project does not support changing target languages through a Change Order. If you would like to translate into new languages, please start a new project.',
    CHANGE_ORDER_INTERNAL_TRANSLATOR_ACCEPT : 'By clicking Accept, you agree to deliver the work requested in this change order. Are you sure?',
    CHANGE_ORDER_CUSTOMER_ACCEPT :'By clicking Accept, you agree to pay the updated quote total that includes the additional work requested in this change order.  Are you sure?',
    PROJECT_DASHBOARD: "ProjectDashboard",
    OPERATIONAL_COST: "OperationalCost",
    TM_DASHBOARD: "TMDashboard",
    DUPLICATE_INTENDED_USE:"Duplicate Intended Use",
    REQUIRED_NAME:"Name is required",
    CALENDAR_NAVIGATION_ARIA_LABEL : {
      NEXT_MONTH:"Go to next month",
      PREV_MONTH:"Go to previous month",
      NEXT_YEAR:"Go to next year",
      PREV_YEAR:"Go to previous year",
      NEXT_DECADE:"Go to next decade",
      PREV_DECADE:"Go to previous decade",
      NEXT_CENTURY:"Go to next century",
      PREV_CENTURY:"Go to previous century"
    },
    PROJECT_DASHBOARD : {
      PROJECT_STATUS_TOOLTIPS : "Track key details and status by project. Report includes closed projects and projects with quotes approved.",
      DELIVERY_STATUS_TOOLTIPS : "Monitor project delivery status: Late, At Risk, Unknown, and On Time, ensuring timely completion and effective project management. It will help to get timely insights and proactive actions.",
      REVIEWER_REPORT_TOOLTIPS : "Track and analyze project edits and feedback with our 'Edits and Feedback Summary' widget, providing insights into reviewer activity and project refinement.",
      LANGUAGE_STATUS_TOOLTIPS : "Track key details and status for each project by language. Report includes closed projects and projects with quotes approved.",
      ASSET_BY_LANGUAGE_TOOLTIPS : "Visualize asset distribution across languages, optimizing localization efforts and enhancing multilingual content strategy.",
      WORKFLOW_STATUS_TOOLTIPS : "Track number of projects for each workflow. Report includes closed projects and projects with quotes approved.",
    },
    OPERATIONAL_COST : {
      INTENDED_USE_TOOLTIPS : "Track spending by different intended uses of the project. Report includes all closed projects and projects with all languages approved.",
      PURCHASE_ORDER_TOOLTIPS : "Track spending by different purchase orders. Report includes all closed projects and projects with all languages approved.",
      LANGUAGE_TOOLTIPS : "Track spending by different target languages. Report includes all closed projects and projects with all languages approved.",
      VENDORS_TOOLTIPS : "Track spending by different translation vendors. Report includes all closed projects and projects with all languages approved.",
      WORK_ITEM_TOOLTIPS : "Track spending by different work items for the project. Work items are quote lines submitted by vendors when quoting for your projects. Report includes all closed projects and projects with all languages approved."
    },
    TM_DASHBOARD : {
      WORD_COUNT_TOOLTIPS : "Track total word count by given period.",
      TOTAL_WORD_COUNT_TOOLTIPS : "Track total word count by language by given period.",
      TM_WORD_COUNT_TOOLTIPS : "Track total TM word count by given period.",
      TM_COST_SAVINGS_TOOLTIPS : "Track total cost savings due to translation memory across all projects by month, based on the difference between what you paid and what the cost of your projects would have been without translation memory.",
      TM_LEVERAGING_TOOLTIPS : "Track vendor-provided TM leveraging data for all projects by given period. Report includes closed projects only."
    },
    PART_OF_SPEECH_ERROR_MSG:'A term with the same source text and part of speech already exists.',
    GLOSSARY_PROCESSING:'Your glossary upload is being processed and will be ready shortly.',
    PAST_CAMPAIGN_MSG:'The selected campaign has a due date after the project translation deadline. If this is incorrect, please select a different campaign .',
    BIDLESS : {
      TRANSLATION_REQUEST_PENDING:"Waiting for Vendor to Respond",
      TRANSLATION_REQUEST_ACCEPTED:'Request Accepted',
      TRANSLATION_REQUEST_REJECTED:'Request Rejected'
    } ,
  SYNC_ERROR :{
    SOURCE_SYNC_ERROR_RETRYABLE :"OPAL-Marketing encountered errors while attempting to prepare your selected source assets. We will automatically attempt to prepare your assets again after some time. If you would like to retry sooner, click Retry. The following assets could not be prepared:",
    SOURCE_SYNC_ERROR_NOT_RETRYABLE :"OPAL-Marketing encountered errors while attempting to prepare your selected source assets. The following assets could not be prepared:"
  }  ,
  DATE_RANGE_VALUES :[
    { code:"last_1_month", unit : "month", value : 1 },
    { code:"last_3_months", unit : "month", value : 3 },
    { code:"last_6_months", unit : "month", value : 6 },
    { code:"last_12_months", unit : "month", value : 12 },
    { code:"custom", unit : "month", value : 1 }
  ],
  DEFAULT_DATE_RANGE :{ code:"last_3_months", unit : "month", value : 3 },
  PERMISSION:"You do not have access to the requested functionality.",
  TODAY:"Today",
  YESTERDAY:"Yesterday",
  PAST_DATE:"Past date",
  ASC:"asc",
  DEACTIVATE_LAST_WORKFLOW : 'Please make sure there is at least one active workflow template in your organization to create projects with. We are unable to deactivate this workflow template because it is the only active template in your organization.',
  FILE_FORMATS_ARIA_LABEL : 'more formats : DITA_Files,DOCX,HTM,IDML,JAVA_PROP,MIF,Open_Office_Files,PHP, PO, POT,PPTX,PSD,RAIL,RESX,SRT,TXT,XML',
  DATE_FORMAT_D_MMM_YYYY :"D-MMM-YYYY",
  ERROR: "error",
  WARNING: "warning",
  ACCEPT: "accept",
  REJECT: "reject",
  ACCEPTED: "ACCEPTED",
  REJECTED: "REJECTED",
  ACCEPT_MEMBER_REQUEST: "Accept Member Request",
  REJECT_MEMBER_REQUEST: "Reject Member Request",
  POPUP_MESSAGES : {
    "reject": "Are you sure you want to reject the request from {name}?",
    "accept": "Are you sure you want to add {name} to this campaign?"
  },
  TRUE: "true",
  STATUS: "Status",
  LANGUAGES: "Languages",
  ASSIGNED_TO: "Assigned To",
  TYPE: "Type",
  ADVANCE_FILTERS: {
    "closed": "closed",
    "outliers": "outliers"
  },
  SUBSCRIBER_INVOICE_STATUS: {
    "customer_invoice_no_action": "CUSTOMER_INVOICE_NO_ACTION",
    "customer_invoice_sent": "CUSTOMER_INVOICE_SENT",
    "customer_invoice_paid": "CUSTOMER_INVOICE_PAID"
  },
  SERVICE_PROVIDER_INVOICE_STATUS: {
    "vendor_invoice_no_action": "VENDOR_INVOICE_NO_ACTION",
    "vendor_invoice_received": "VENDOR_INVOICE_RECEIVED",
    "vendor_invoice_paid": "VENDOR_INVOICE_PAID"
  },
  FINANCE_PROJECT_CHUNK_SIZE: 100,
  SAVE: "Save",
  ACCOUNT_NAME: "Account_Name",
  PROJECT_CLOSED: "Project Closed",
  TIMEZONE_PST: "America/Los_Angeles",
  PROJECT_STATUS: {
    "closed" : "project_closed"
  },
  USD: "USD"
}
export default Constants;

